import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import DashboardHeader from "../../../components/dashboard/dashboardHeader";
import { MicrosoftConnectPanel } from "../../../components/dashboard/microsoft/MicrosoftConnectPanel";
import { UserMicrosoftCalendarSection } from "../../../components/dashboard/microsoft/UserMicrosoftCalendarSection";
import {
  disconnectUserMicrosoft,
  fetchUserMicrosoftStatus,
} from "../../../api/microsoft";
import { UserPersonalMailAiSection } from "../../../components/dashboard/microsoft/UserPersonalMailAiSection";

/**
 * Koble Microsoft / Outlook til Promang-kontoen (innlogget bruker).
 * Samme flyt som under Innstillinger — egen URL for bokmerke/meny.
 *
 * Kalender for hendelser: `UserMicrosoftCalendarSection` henter alle kalendere du har tilgang til
 * i Graph (`/me/calendars`, inkl. delte) og åpner søkbar velger (modal, samme mønster som ModernProductSelector).
 */
export function UserMicrosoftOutlook() {
  const { t } = useTranslation();
  const [microsoftStatus, setMicrosoftStatus] = useState(null);

  const fetchStatus = useCallback(async () => {
    try {
      return await fetchUserMicrosoftStatus();
    } catch (e) {
      const status = e?.response?.status;
      if (status === 404 || status === 501) {
        return { connected: false, apiMissing: true };
      }
      return { connected: false };
    }
  }, []);

  const refreshMicrosoftStatus = useCallback(() => {
    fetchStatus().then(setMicrosoftStatus);
  }, [fetchStatus]);

  return (
    <DashboardHeader
      title={t("microsoft.user.page_title")}
      subtitle={t("microsoft.user.page_subtitle")}
      meta={[]}
      actions={[]}
    >
      <div className="mx-auto mt-8 max-w-3xl space-y-8 px-4 pb-16 sm:px-6 lg:max-w-4xl">
        <MicrosoftConnectPanel
          variant="user"
          titleKey="microsoft.user.card_title"
          intent="user_mail"
          fetchStatus={fetchStatus}
          onDisconnect={disconnectUserMicrosoft}
          onStatusChange={setMicrosoftStatus}
        />
        <UserMicrosoftCalendarSection
          status={microsoftStatus}
          onSaved={refreshMicrosoftStatus}
        />
        <UserPersonalMailAiSection
          microsoftStatus={microsoftStatus}
          onMailAiChanged={refreshMicrosoftStatus}
        />
      </div>
    </DashboardHeader>
  );
}
